"use client"

import * as React from "react"
import { Eye, EyeOff } from "lucide-react"
import { useHideContext } from "./HideContext"

interface HideProps {
  /** 隠したいテキスト */
  children: React.ReactNode
  /** 非表示時に置き換える文字列 (デフォルトは "???") */
  maskChar?: string
}

/**
 * インラインで「隠す／表示」を切り替えられるコンポーネント。
 *  - 初期状態: maskChar (青文字)
 *  - 表示後: children (青文字)
 */
export function Hide({ children, maskChar = "???" }: HideProps) {
  const [revealed, setRevealed] = React.useState(false)
  const { register, unregister } = useHideContext()

  React.useEffect(() => {
    register(setRevealed)
    return () => {
      unregister(setRevealed)
    }
  }, [register, unregister])

  const toggle = () => {
    setRevealed((prev) => !prev)
  }

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={toggle}
      onKeyPress={toggle}
      /*
        全体を青文字にして、ホバー時に下線を出す。
        （文章中でも常に青文字）
      */
      className="inline-flex items-center gap-1 text-blue-500 hover:underline cursor-pointer select-none"
    >
      {/* 非表示or表示の切り替え */}
      {revealed ? children : maskChar}

      {/* Eyeアイコン切り替え */}
      {revealed ? (
        <EyeOff className="w-4 h-4" aria-label="隠す" />
      ) : (
        <Eye className="w-4 h-4" aria-label="表示する" />
      )}
    </span>
  )
}
